import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Aarthikreportnamuna13 = () => {
  const navigate = useNavigate();

  const handleSubmit = () => {
    console.log('Form submitted');
  };

  const handleBack = () => {
    navigate('/aarthikreport');
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          
          {/* Header */}
          <div className="bg-[#267c77] text-white px-6 py-4 text-center">
            <h1 className="text-xl font-bold">नमुना 13</h1>
          </div>

          {/* Back Button */}
          <div className="px-6 py-4 bg-gray-50 border-b">
            <button
              onClick={handleBack}
              className="flex items-center gap-2 bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700 transition-colors duration-200"
            >
              ← Back
            </button>
          </div>

          {/* Form Content */}
          <div className="p-6">
            <div className="space-y-6">
              
              {/* Content Area - Placeholder for form content */}
              <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
                <p className="text-gray-600 text-center">
                  येथे नमुना 13 चा अंमलबंधित फॉर्म दाखवला जाईल
                </p>
                <p className="text-gray-500 text-sm text-center mt-2">
                  Form content will be displayed here
                </p>
              </div>

            </div>

            {/* Submit Button */}
            <div className="mt-8 flex justify-center">
              <button
                onClick={handleSubmit}
                className="bg-green-600 text-white px-8 py-3 rounded-md font-medium hover:bg-green-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
              >
                नमुना 13
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Aarthikreportnamuna13;